import classNames from 'classnames';
import React, { useRef, useState, useEffect, useMemo, useCallback } from 'react';

import styles from './SlideDownReveal.module.css';

export default function SlideDownReveal(props) {
  const { children, className } = props;

  const ref = useRef(null);
  const [height, setHeight] = useState(props.in ? 'initial' : 0);

  // On initial load, we want to calculate the height of the component, too
  // otherwise the animation won't work without a hard height
  useEffect(() => {
    if (ref) {
      if (props.in) {
        setHeight(ref.current.clientHeight);
      } else {
        setHeight(0);
      }
    }
  }, [props.in]);

  return (
    <div className={classNames(styles.slideDownReveal, className)} style={{ height }}>
      <div ref={ref}>{children}</div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/elements/SlideDownReveal/index.js